"use strict";

var _classCallCheck = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TupleDataType = void 0;

var ethereum_types_1 = require("ethereum-types");

var _ = require("lodash");

var set_1 = require("../abstract_data_types/types/set");

var TupleDataType = /*#__PURE__*/function (_set_1$AbstractSetDat) {
  _inherits(TupleDataType, _set_1$AbstractSetDat);

  var _super = _createSuper(TupleDataType);

  _createClass(TupleDataType, null, [{
    key: "matchType",
    value: function matchType(type) {
      return type === ethereum_types_1.SolidityTypes.Tuple;
    }
  }]);

  function TupleDataType(dataItem, dataTypeFactory) {
    var _this;

    _classCallCheck(this, TupleDataType);

    _this = _super.call(this, dataItem, dataTypeFactory);

    if (!TupleDataType.matchType(dataItem.type)) {
      throw new Error("Tried to instantiate Tuple with bad input: ".concat(dataItem));
    }

    return _this;
  }

  _createClass(TupleDataType, [{
    key: "getSignatureType",
    value: function getSignatureType() {
      return this._computeSignatureOfMembers(false);
    }
  }, {
    key: "getSignature",
    value: function getSignature(isDetailed) {
      if (_.isEmpty(this.getDataItem().name) || !isDetailed) {
        return this.getSignatureType();
      }

      var name = this.getDataItem().name;
      var lastIndexOfScopeDelimiter = name.lastIndexOf('.');
      var isScopedName = lastIndexOfScopeDelimiter !== undefined && lastIndexOfScopeDelimiter > 0;
      var shortName = isScopedName ? name.substr(lastIndexOfScopeDelimiter + 1) : name;
      var detailedSignature = "".concat(shortName, " ").concat(this._computeSignatureOfMembers(isDetailed));
      return detailedSignature;
    }
  }]);

  return TupleDataType;
}(set_1.AbstractSetDataType);

exports.TupleDataType = TupleDataType;